export const EVENTS = {
    CLICK: 'click',
};

export const ATTRIBUTES = {
    INTERCEPT_CLICK: 'intercept-click',
};
